import React, { useState } from "react";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { RemoveRedEye } from "@mui/icons-material";
import {
  CustomTableContainer,
  CustomTableHead,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import { useSelector, useDispatch } from "react-redux";
import { AdminTitleHolder } from "../../../common/sharedComponents/styles/card.style";
import { getBusinessUnitUsers } from "../redux/businessUnitSlice";

function BusinessUnitViewCompanyList() {
  const dispatch = useDispatch();
  const { businessUnitDetails, businessUnitUsers } = useSelector(
    (state) => state.businessUnit,
  );
  const [open, setOpen] = useState(false);
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const handleViewUsers = (company) => {
    const name = company?.company?.company_name;
    const companyId = company?.company?.id;
    const businessUnitId = businessUnitDetails?.businessUnit?.id;
    setSelectedCompanyName(name);
    setOpen(true);
    if (companyId && businessUnitId) {
      dispatch(getBusinessUnitUsers({ companyId, businessUnitId }));
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedCompanyName("");
  };

  return (
    <div>
      <AdminTitleHolder sx={{ mt: 2 }}>
        <b>Assigned Companies</b>
      </AdminTitleHolder>
      <CustomTableContainer component={Card}>
        <Table>
          <CustomTableHead>
            <TableRow>
              <TableCell>
                <TableHeaderFont>Company Name</TableHeaderFont>
              </TableCell>
              <TableCell>
                <TableHeaderFont>User Count</TableHeaderFont>
              </TableCell>
              <TableCell>
                <TableHeaderFont>Action</TableHeaderFont>
              </TableCell>
            </TableRow>
          </CustomTableHead>
          <TableBody>
            {businessUnitDetails?.companies?.length > 0 ? (
              businessUnitDetails.companies.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item?.company?.company_name || "-"}</TableCell>
                  <TableCell>{item?.userCount || 0}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleViewUsers(item)}>
                      <RemoveRedEye sx={{ fontSize: 18, color: "royalblue" }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  No companies assigned
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CustomTableContainer>

      {/* Users Modal */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>Users - {selectedCompanyName}</DialogTitle>
        <DialogContent>
          <CustomTableContainer component={Card}>
            <Table>
              <CustomTableHead>
                <TableRow>
                  <TableCell>
                    <TableHeaderFont>Name</TableHeaderFont>
                  </TableCell>
                  <TableCell>
                    <TableHeaderFont>Email</TableHeaderFont>
                  </TableCell>
                </TableRow>
              </CustomTableHead>
              <TableBody>
                {businessUnitUsers?.users?.length > 0 ? (
                  businessUnitUsers.users.map((item, idx) => (
                    <TableRow key={idx}>
                      <TableCell>
                        {item?.user?.first_name && item?.user?.last_name
                          ? `${item.user.first_name} ${item.user.last_name}`
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {item?.user?.contact_person_email || "-"}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      No users found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </CustomTableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default BusinessUnitViewCompanyList;
